import ViewCashSales from "../../../../components/@documents/cash_sales/ViewCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CashSalesViewPage() {

    return (
        <ViewCashSales 
            routeType={routeTypes.admin}
        />
    )
}